import { useUserSettings } from "@/features/User/hooks/useUserSettings";
import { enable_registration_flag } from "@/services/posthog/feature_flags";
import { Flex, Modal, ModalBody, ModalContent, ModalOverlay, Stack, Text, useDisclosure } from "@chakra-ui/react";
import { PromptStudioLogo } from "@pufflig/prompt-studio-ui";
import { useFeatureFlagEnabled } from "posthog-js/react";
import { useEffect, useState } from "react";
import { DataSetupStep } from "./DataSetupStep";
import { ProfileInfoStep } from "./ProfileInfoStep";

export const RegistrationForm = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { data: userSettings } = useUserSettings();
  const [step, setStep] = useState<"profile" | "data">("profile");
  const registrationEnabled = useFeatureFlagEnabled(enable_registration_flag);

  useEffect(() => {
    if (userSettings?.isProfileSetupComplete) {
      setStep("data");
    }

    if (registrationEnabled && userSettings && !userSettings.isDataSetupComplete) {
      onOpen();
    }
  }, [onOpen, userSettings]);

  if (!registrationEnabled || userSettings?.isDataSetupComplete) {
    return null;
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md" isCentered closeOnOverlayClick={false} closeOnEsc={false}>
      <ModalOverlay />
      <ModalContent p="spacing-xxl">
        <ModalBody>
          <Stack spacing="spacing-md" textAlign="left">
            <Flex width="4rem" justifyContent={"center"} alignSelf="center">
              <PromptStudioLogo />
            </Flex>
            <Text textAlign={"center"} textStyle="heading/3">
              Profile Setup
            </Text>
            <Text textAlign="center" textStyle="label/L/regular">
              <Text
                as="span"
                fontWeight={step === "profile" ? "semi-bold" : "normal"}
                color={step === "profile" ? "foreground.primary" : "foreground.tertiary"}
              >
                Profile information
              </Text>{" "}
              &gt;{" "}
              <Text
                as="span"
                fontWeight={step === "data" ? "semi-bold" : "normal"}
                color={step === "data" ? "foreground.primary" : "foreground.tertiary"}
              >
                Data selection
              </Text>
            </Text>
            <Stack mt="spacing-xl">
              {step === "profile" && (
                <ProfileInfoStep
                  onSubmit={() => {
                    setStep("data");
                  }}
                />
              )}
              {step === "data" && (
                <DataSetupStep
                  onSubmit={() => {
                    onClose();
                  }}
                />
              )}
            </Stack>
          </Stack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
